import { AnimatePresence, motion } from 'motion/react';

import { Icon } from '@flintmint/web-shared/components/icon';

import { animateScaleAndOpacity } from '@flintmint/web-shared/constants/ui';

export const CopyFeedbackIcon = ({ copied, size }: CopyFeedbackIconProps) => (
  <AnimatePresence mode="wait" initial={false}>
    <motion.span key={copied ? 'tick' : 'copy'} {...animateScaleAndOpacity}>
      <Icon type={copied ? 'tick-02' : 'copy-01'} size={size} />
    </motion.span>
  </AnimatePresence>
);

interface CopyFeedbackIconProps {
  size: number;
  copied: boolean;
}
